import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-state-fund-preview',
  templateUrl: './state-fund-preview.component.html',
  styleUrls: ['./state-fund-preview.component.css']
})
export class StateFundPreviewComponent {
  SelectedTool: string;
  constructor(private readonly router: Router, private sessionStorageService: SessionStorageService) {
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
  }

  backNavigation() {
    let stateId = sessionStorage.getItem('StateSetupManageRedirection');
    let URL = '';
    if (sessionStorage.getItem('isClickOnState') != 'true') {      
      sessionStorage.removeItem('StateSetupManageRedirection');
      URL = 'admin/' + this.SelectedTool + '/state/setup/manage/' + stateId;
    }
    else {
      sessionStorage.removeItem('isClickOnState')
      URL = 'admin/' + this.SelectedTool + '/states';
    }
    this.router.navigate([URL]);
  }
}
